// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".topbar-drawer-input{padding:0 40px 10px 20px}.topbar-drawer-input .ant-input-affix-wrapper{height:40px;padding:0 40px 0 20px;border-radius:0;font-size:14px;border:unset;border-bottom:1px solid #ddd;box-shadow:unset;padding:0 20px;font-weight:400}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
